// extracted by mini-css-extract-plugin
export default {"toastWrapper":"styles_toastWrapper__POhZC"};